module.exports = __webpack_public_path__ + "static/img/ECOP_3@2x.e105de95.png";